import { Component, Input } from '@angular/core';


@Component({
  selector: 'layout-vertical-slider-bullet',
  templateUrl: './layout-vertical-slider-bullet.component.html',
  styleUrls: ['./layout-vertical-slider-bullet.component.scss']
})
export class LayoutVerticalSliderBulletComponent {

  @Input() public selected: boolean = false;

}
